import { lazy } from "react";
import {
  GENERAL_ROUTES_CONFIG,
  PURCHASE_ORDERS_ROUTES_CONFIG,
  TRANSFER_ORDERS_ROUTES_CONFIG,
  ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES_CONFIG,
  ACTIVE_ANTS_WAREHOUSE_CHECK_INS_ROUTES_CONFIG,
  FINANCE_ROUTES_CONFIG,
  USERS_ROUTES_CONFIG,
  VENDORS_ROUTES_CONFIG,
  WAREHOUSE_CHECK_INS_ROUTES_CONFIG,
  CLAIMS_ROUTES_CONFIG,
  RELABELLING_ROUTES_CONFIG,
  BRAND_ROUTES_CONFIG
} from "src/constants/routesConfig";
import { Route } from "src/types";

export const GENERAL_ROUTES = {
  forbidden: {
    ...GENERAL_ROUTES_CONFIG.forbidden,
    Component: lazy(() => import("src/pages/general/forbidden"))
  },
  info: {
    ...GENERAL_ROUTES_CONFIG.info,
    Component: lazy(() => import("src/pages/general/info"))
  }
} satisfies Record<string, Route>;

export const PURCHASE_ORDERS_ROUTES = {
  createPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.createPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/createPurchaseOrder"))
  },
  uploadPurchaseOrders: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.uploadPurchaseOrders,
    Component: lazy(() => import("src/pages/purchaseOrders/uploadPurchaseOrders"))
  },
  sendPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.sendPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/sendPurchaseOrder"))
  },
  updatePurchaseOrderConfirmation: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.updatePurchaseOrderConfirmation,
    Component: lazy(() => import("src/pages/purchaseOrders/updatePurchaseOrderConfirmation"))
  },
  reviewPurchaseOrderConfirmation: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.reviewPurchaseOrderConfirmation,
    Component: lazy(() => import("src/pages/purchaseOrders/reviewPurchaseOrderConfirmation"))
  },
  updatePurchaseOrderInvoice: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.updatePurchaseOrderInvoice,
    Component: lazy(() => import("src/pages/purchaseOrders/updatePurchaseOrderInvoice"))
  },
  amendPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.amendPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/amendPurchaseOrder"))
  },
  amendTransitPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.amendTransitPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/amendTransitPurchaseOrder"))
  },
  createChildPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.createChildPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/createChildPurchaseOrder"))
  },
  confirmChildPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.confirmChildPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/confirmChildPurchaseOrder"))
  },
  updatePurchaseOrderShipmentDetails: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.updatePurchaseOrderShipmentDetails,
    Component: lazy(() => import("src/pages/purchaseOrders/updatePurchaseOrderShipmentDetails"))
  },
  purchaseOrdersDashboard: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.purchaseOrdersDashboard,
    Component: lazy(() => import("src/pages/purchaseOrders/purchaseOrdersDashboard"))
  },
  subPurchaseOrdersDashboard: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.subPurchaseOrdersDashboard,
    Component: lazy(() => import("src/pages/purchaseOrders/subPurchaseOrdersDashboard"))
  },
  subPurchaseOrder: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.subPurchaseOrder,
    Component: lazy(() => import("src/pages/purchaseOrders/subPurchaseOrder"))
  },
  transitPurchaseOrdersDashboard: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.transitPurchaseOrdersDashboard,
    Component: lazy(() => import("src/pages/purchaseOrders/transitPurchaseOrdersDashboard"))
  },
  purchaseOrders: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.purchaseOrders,
    Component: lazy(() => import("src/pages/purchaseOrders/purchaseOrders"))
  },
  receivingDiscrepancies: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.receivingDiscrepancies,
    Component: lazy(() => import("src/pages/purchaseOrders/receivingDiscrepancies/receivingDiscrepancies"))
  },
  resolveGXOError: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.resolveGXOError,
    Component: lazy(() => import("src/pages/purchaseOrders/resolveGXOError"))
  },
  parcelHeroTimeline: {
    ...PURCHASE_ORDERS_ROUTES_CONFIG.parcelHeroTimeline,
    Component: lazy(() => import("src/pages/purchaseOrders/parcelHeroTimeline"))
  }
} satisfies Record<string, Route>;

export const TRANSFER_ORDERS_ROUTES = {
  createTransferOrder: {
    ...TRANSFER_ORDERS_ROUTES_CONFIG.createTransferOrder,
    Component: lazy(() => import("src/pages/transferOrders/createTransferOrder"))
  },
  transferOrdersDashboard: {
    ...TRANSFER_ORDERS_ROUTES_CONFIG.transferOrdersDashboard,
    Component: lazy(() => import("src/pages/transferOrders/transferOrdersDashboard"))
  },
  transferOrder: {
    ...TRANSFER_ORDERS_ROUTES_CONFIG.transferOrder,
    Component: lazy(() => import("src/pages/transferOrders/transferOrder"))
  }
} satisfies Record<string, Route>;

export const ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES = {
  activeAntsPurchaseOrdersDashboard: {
    ...ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES_CONFIG.activeAntsPurchaseOrdersDashboard,
    Component: lazy(() => import("src/pages/activeAntsPurchaseOrders/activeAntsPurchaseOrdersDashboard"))
  },
  activeAntsPurchaseOrder: {
    ...ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES_CONFIG.activeAntsPurchaseOrder,
    Component: lazy(() => import("src/pages/activeAntsPurchaseOrders/activeAntsPurchaseOrder"))
  },
  resolveAAError: {
    ...ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES_CONFIG.resolveAAError,
    Component: lazy(() => import("src/pages/activeAntsPurchaseOrders/resolveAAError"))
  },
  activeAntsReceivingDiscrepancies: {
    ...ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES_CONFIG.activeAntsReceivingDiscrepancies,
    Component: lazy(() => import("src/pages/activeAntsReceivingDiscrepancies/activeAntsReceivingDiscrepancies"))
  }
} satisfies Record<string, Route>;

export const ACTIVE_ANTS_WAREHOUSE_CHECK_INS_ROUTES = {
  activeAntsWarehouseCheckInsDashboard: {
    ...ACTIVE_ANTS_WAREHOUSE_CHECK_INS_ROUTES_CONFIG.activeAntsWarehouseCheckInsDashboard,
    Component: lazy(() => import("src/pages/activeAntsWarehouseCheckIns/activeAntsWarehouseCheckInsDashboard"))
  },
  activeAntsWarehouseCheckIn: {
    ...ACTIVE_ANTS_WAREHOUSE_CHECK_INS_ROUTES_CONFIG.activeAntsWarehouseCheckIn,
    Component: lazy(() => import("src/pages/activeAntsWarehouseCheckIns/activeAntsWarehouseCheckIn"))
  },
  activeAntsGoodsInExports: {
    ...ACTIVE_ANTS_WAREHOUSE_CHECK_INS_ROUTES_CONFIG.activeAntsGoodsInExports,
    Component: lazy(() => import("src/pages/activeAntsWarehouseCheckIns/activeAntsGoodsInExports"))
  }
} satisfies Record<string, Route>;

export const FINANCE_ROUTES = {
  invoiceExports: {
    ...FINANCE_ROUTES_CONFIG.invoiceExports,
    Component: lazy(() => import("src/pages/finance/invoiceExports"))
  },
  legacyInvoiceExports: {
    ...FINANCE_ROUTES_CONFIG.legacyInvoiceExports,
    Component: lazy(() => import("src/pages/finance/legacyInvoiceExports"))
  },
  hmrcExchangeRates: {
    ...FINANCE_ROUTES_CONFIG.hmrcExchangeRates,
    Component: lazy(() => import("src/pages/finance/hmrcExchangeRatesDashboard"))
  }
} satisfies Record<string, Route>;

export const USERS_ROUTES = {
  userAccountsDashboard: {
    ...USERS_ROUTES_CONFIG.userAccountsDashboard,
    Component: lazy(() => import("src/pages/users/userAccountsDashboard"))
  },
  createUserAccount: {
    ...USERS_ROUTES_CONFIG.createUserAccount,
    Component: lazy(() => import("src/pages/users/createUserAccount"))
  },
  updateUserAccount: {
    ...USERS_ROUTES_CONFIG.updateUserAccount,
    Component: lazy(() => import("src/pages/users/updateUserAccount"))
  },
  purchaseOrderBarcodeLookup: {
    ...USERS_ROUTES_CONFIG.purchaseOrderBarcodeLookup,
    Component: lazy(() => import("src/pages/purchaseOrders/purchaseOrderBarcodeLookup"))
  },
  profile: {
    ...USERS_ROUTES_CONFIG.profile,
    Component: lazy(() => import("src/pages/users/profile"))
  },
  userEmailVerification: {
    ...USERS_ROUTES_CONFIG.userEmailVerification,
    Component: lazy(() => import("src/pages/users/userEmailVerification"))
  },
  updateUserSettings: {
    ...USERS_ROUTES_CONFIG.updateUserSettings,
    Component: lazy(() => import("src/pages/users/updateUserSettings"))
  }
} satisfies Record<string, Route>;

export const VENDORS_ROUTES = {
  vendorsDashboard: {
    ...VENDORS_ROUTES_CONFIG.vendorAccountsDashboard,
    Component: lazy(() => import("src/pages/vendors/vendorsDashboard"))
  },
  createVendor: {
    ...VENDORS_ROUTES_CONFIG.createVendor,
    Component: lazy(() => import("src/pages/vendors/createVendor"))
  },
  updateVendor: {
    ...VENDORS_ROUTES_CONFIG.updateVendor,
    Component: lazy(() => import("src/pages/vendors/updateVendor"))
  },
  bulkEmailToVendors: {
    ...VENDORS_ROUTES_CONFIG.bulkEmailToVendors,
    Component: lazy(() => import("src/pages/vendors/bulkEmailToVendors"))
  }
} satisfies Record<string, Route>;

export const WAREHOUSE_CHECK_INS_ROUTES = {
  checkInUnknownArrival: {
    ...WAREHOUSE_CHECK_INS_ROUTES_CONFIG.checkInUnknownArrival,
    Component: lazy(() => import("src/pages/warehouseCheckIns/checkInUnknownArrival"))
  },
  checkInPurchaseOrder: {
    ...WAREHOUSE_CHECK_INS_ROUTES_CONFIG.checkInPurchaseOrder,
    Component: lazy(() => import("src/pages/warehouseCheckIns/checkInPurchaseOrder"))
  },
  warehouseCheckInsDashboard: {
    ...WAREHOUSE_CHECK_INS_ROUTES_CONFIG.warehouseCheckInsDashboard,
    Component: lazy(() => import("src/pages/warehouseCheckIns/warehouseCheckInsDashboard"))
  },
  warehouseCheckIns: {
    ...WAREHOUSE_CHECK_INS_ROUTES_CONFIG.warehouseCheckIns,
    Component: lazy(() => import("src/pages/warehouseCheckIns/warehouseCheckIns"))
  },
  goodsInExports: {
    ...WAREHOUSE_CHECK_INS_ROUTES_CONFIG.goodsInExports,
    Component: lazy(() => import("src/pages/warehouseCheckIns/goodsInExports"))
  },
  unknownArrivals: {
    ...WAREHOUSE_CHECK_INS_ROUTES_CONFIG.unknownArrivals,
    Component: lazy(() => import("src/pages/warehouseCheckIns/unknownArrivals/unknownArrivals"))
  }
} satisfies Record<string, Route>;

export const CLAIMS_ROUTES = {
  claimsDashboard: {
    ...CLAIMS_ROUTES_CONFIG.claimsDashboard,
    Component: lazy(() => import("src/pages/claims/claimsDashboard"))
  },
  createClaim: {
    ...CLAIMS_ROUTES_CONFIG.createClaim,
    Component: lazy(() => import("src/pages/claims/createClaim"))
  },
  editClaim: {
    ...CLAIMS_ROUTES_CONFIG.editClaim,
    Component: lazy(() => import("src/pages/claims/editClaim"))
  },
  claim: {
    ...CLAIMS_ROUTES_CONFIG.claim,
    Component: lazy(() => import("src/pages/claims/claim"))
  },
  reviewClaimConfirmation: {
    ...CLAIMS_ROUTES_CONFIG.reviewClaimConfirmation,
    Component: lazy(() => import("src/pages/claims/reviewClaimConfirmation"))
  }
} satisfies Record<string, Route>;

export const RELABELLING_ROUTES = {
  euRelabelCheckIn: {
    ...RELABELLING_ROUTES_CONFIG.euRelabelCheckIn,
    Component: lazy(() => import("src/pages/relabelling/euRelabelCheckIn"))
  },
  relabelCaseBuilder: {
    ...RELABELLING_ROUTES_CONFIG.relabelCaseBuilder,
    Component: lazy(() => import("src/pages/relabelling/relabelCaseBuilder"))
  },
  relabelCaseTracking: {
    ...RELABELLING_ROUTES_CONFIG.relabelCaseTracking,
    Component: lazy(() => import("src/pages/relabelling/relabelCaseTracking"))
  },
  palletBuilder: {
    ...RELABELLING_ROUTES_CONFIG.palletBuilder,
    Component: lazy(() => import("src/pages/relabelling/palletBuilder"))
  },
  createPallet: {
    ...RELABELLING_ROUTES_CONFIG.createPallet,
    Component: lazy(() => import("src/pages/relabelling/createPallet"))
  },
  viewPallet: {
    ...RELABELLING_ROUTES_CONFIG.viewPallet,
    Component: lazy(() => import("src/pages/relabelling/viewPallet"))
  },
  editPallet: {
    ...RELABELLING_ROUTES_CONFIG.editPallet,
    Component: lazy(() => import("src/pages/relabelling/editPallet"))
  },
  shipmentManager: {
    ...RELABELLING_ROUTES_CONFIG.shipmentManager,
    Component: lazy(() => import("src/pages/relabelling/shipmentManager"))
  },
  createShipment: {
    ...RELABELLING_ROUTES_CONFIG.createShipment,
    Component: lazy(() => import("src/pages/relabelling/createShipment"))
  },
  editShipment: {
    ...RELABELLING_ROUTES_CONFIG.editShipment,
    Component: lazy(() => import("src/pages/relabelling/editShipment"))
  },
  viewShipment: {
    ...RELABELLING_ROUTES_CONFIG.viewShipment,
    Component: lazy(() => import("src/pages/relabelling/viewShipment"))
  }
} satisfies Record<string, Route>;

export const BRAND_ROUTES = {
  brandOnboarding: {
    ...BRAND_ROUTES_CONFIG.brandOnboarding,
    Component: lazy(() => import("src/pages/brands/BrandOnboardingPage"))
  },
  brandSubmissionStatus: {
    ...BRAND_ROUTES_CONFIG.brandSubmissionStatus,
    Component: lazy(() => import("src/pages/brands/BrandSubmissionStatusPage"))
  },
  brandSubmissionResubmit: {
    ...BRAND_ROUTES_CONFIG.brandSubmissionResubmit,
    Component: lazy(() => import("src/pages/brands/BrandSubmissionResubmitPage"))
  },
  brandSubmissions: {
    ...BRAND_ROUTES_CONFIG.brandSubmissions,
    Component: lazy(() => import("src/pages/brands/BrandSubmissionsPage"))
  },
  brandSubmissionDetail: {
    ...BRAND_ROUTES_CONFIG.brandSubmissionDetail,
    Component: lazy(() => import("src/pages/brands/BrandSubmissionDetailPage"))
  }
} satisfies Record<string, Route>;

const LEGACY_CLAIM_REDIRECT_ROUTES = {
  legacyEditClaim: {
    displayName: "Edit Claim",
    path: "/edit-claim",
    roleRequired: "WHITELISTED",
    isPublic: true,
    Component: lazy(() => import("src/pages/general/legacyClaimRedirect"))
  },
  legacyClaim: {
    displayName: "Claim",
    path: "/claim",
    roleRequired: "WHITELISTED",
    isPublic: true,
    Component: lazy(() => import("src/pages/general/legacyClaimRedirect"))
  },
  legacyReviewClaimConfirmation: {
    displayName: "Review Claim Confirmation",
    path: "/review-claim-confirmation",
    roleRequired: "WHITELISTED",
    isPublic: true,
    Component: lazy(() => import("src/pages/general/legacyClaimRedirect"))
  }
} satisfies Record<string, Route>;

const ROUTES: Record<string, Route> = {
  ...GENERAL_ROUTES,
  ...PURCHASE_ORDERS_ROUTES,
  ...TRANSFER_ORDERS_ROUTES,
  ...ACTIVE_ANTS_PURCHASE_ORDERS_ROUTES,
  ...ACTIVE_ANTS_WAREHOUSE_CHECK_INS_ROUTES,
  ...FINANCE_ROUTES,
  ...USERS_ROUTES,
  ...VENDORS_ROUTES,
  ...WAREHOUSE_CHECK_INS_ROUTES,
  ...CLAIMS_ROUTES,
  ...RELABELLING_ROUTES,
  ...BRAND_ROUTES,
  ...LEGACY_CLAIM_REDIRECT_ROUTES
};

ROUTES.home = {
  displayName: "Home",
  path: "*",
  roleRequired: "WHITELISTED",
  Component: lazy(() => import("src/pages/general/homeRedirect"))
};

export default ROUTES;
